
<app-loading-spinner *ngIf="isLoading" [inline]="1"></app-loading-spinner>
<nav class="subnav" *ngIf="page">
  <div class="prev">
 
  </div>
  <h2>{{ page.title }}</h2>
  <div class="next"></div>
</nav>
<div class="fh pb-10 content-container">
  <div class="row" *ngIf="page">
    <div class="col">
      <img
        src="{{ page.image_filename | getThumbnail : 'medium-landscape' }}"
        alt=""
        class="img-fluid rounded-lg mt-2 mb-3"
        *ngIf="page.image_filename"
      />

     
      <div (click)="onContentClick($event)">
        <div
          [innerHTML]="page?.content | safeHtml"
          *ngIf="page?.page_type_id == 1"
        ></div>
        <div *ngIf="page?.page_type_id == 2">
          <div [innerHTML]="page?.content.content | safeHtml"></div>
        </div>
      </div>
    </div>
  </div>
</div>
